export default __webpack_public_path__ + "static/SR USA - Safety Data Sheet (SDS) - Caramel Color (Powders)-9e50951e16f0b931bf650a7756047925.pdf";